import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CorrelationService {

  private currentId: string | null = null;
  private lastResponseAt: number | null = null;

  // How long (ms) after a response we still consider the next call
  // part of the same logical process. Tune as needed.
  private readonly CHAIN_WINDOW_MS = 2000;

  getCurrentId(): string | null {
    return this.currentId;
  }

  setId(id: string | null): void {
    if (id) {
      this.currentId = id;
      this.lastResponseAt = Date.now();
    }
  }

  resetProcess(): void {
    this.currentId = null;
    this.lastResponseAt = null;
  }

  shouldReuse(): boolean {
    if (!this.currentId || !this.lastResponseAt) {
      return false;
    }
    return (Date.now() - this.lastResponseAt) < this.CHAIN_WINDOW_MS;
  }
}